export const SEARCH_FOCUS = 'footer/SEARCH_FOCUS';
